import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environment';
import {HttpClient, HttpContext, HttpResponse} from '@angular/common/http';
import {Observable, forkJoin, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {IOrderList, IOrderResponse} from '../shared/model/order.model';
import {SHOW_TOAST} from '../login/login.service';

export interface BackendFileResponse {
  fileName: string;
  file: string;
  contentType: string;
}

export type EntityArrayResponseType = HttpResponse<IOrderResponse>;

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private apiWsOrder = `${environment.wsApiBaseUrl}/api/order`
  protected readonly http = inject(HttpClient);

  findByParams(params: any, customerAN?: number | string | null): Observable<EntityArrayResponseType> {
    Object.keys(params).forEach(key => {
      if (params[key] == null || params[key] == "") delete params[key];
    });

    if (customerAN != null) {
      params.customerAN = customerAN;
    }

    return this.http.get<IOrderResponse>(`${this.apiWsOrder}`, {observe: 'response', params: params});
  }

  getOrdersReport(params: any): Observable<HttpResponse<any>> {
    const sanitized: any = { ...params };
    Object.keys(sanitized).forEach(key => {
      if (sanitized[key] == null || sanitized[key] === "") {
        delete sanitized[key];
      }
    });
    return this.http.get<any>(`${this.apiWsOrder}/report`, {observe: 'response', params: sanitized});
  }

  saveAsDraft(body: { userID: number, addressNumber: number, itemsCodeList: any[] }) {
    return this.http.post<IOrderList>(`${this.apiWsOrder}/draft`, body, {observe: 'response'});
  }

  saveAndInvoice(body: { userID: number, addressNumber: number, itemsCodeList: any[], orderID?: number }) {
    return this.http.post<IOrderList>(`${this.apiWsOrder}/invoice`, body, {observe: 'response'});
  }

  deleteOrder(orderId: number | string): Observable<any> {
    return this.http.delete<any>(`${this.apiWsOrder}/${orderId}`);
  }

  downloadOrderExcel(orderNumber: string): Observable<BackendFileResponse> {
    return this.http.get<BackendFileResponse>(`${this.apiWsOrder}/excel/${orderNumber}`);
  }

  getOrderItems(orderId: string, addressNumber?: number | string | null, customerAN?: number | string | null): Observable<any> {
    const params: any = {};
    if (customerAN != null) {
      params.customerAN = customerAN;
    }
    return this.http.get<any>(`${this.apiWsOrder}/items/${orderId}`, {observe: 'response', params});
  }

  massiveLoad(records: any): Observable<HttpResponse<any>> {
    return this.http.post(
      `${this.apiWsOrder}/massive-load`,
      records,
      { 
        observe: 'response',
        context: new HttpContext().set(SHOW_TOAST, false)
      }
    );
  }

  getPlatformLimits(): Observable<any> {
    return this.http.get<any>(`${this.apiWsOrder}/platform-limits`);
  }

  getInvoicedOrdersSummary(params: any): Observable<any> {
    return this.http.get<any>(`${this.apiWsOrder}/invoice/summary`, {observe: 'response', params}).pipe(
      map(response => response.body?.summary)
    );
  }

}
